import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PhoneAuth from "./components/auth/Phoneauth";
import LoginPage from "./pages/LoginPage"; // ✅ New Login Page
import ProtectedRoute from "./components/ProtectedRoute";
import GuestOnly from "./components/GuestOnly";
import Home from "./pages/Home";
import PostRide from "./pages/PostRide";
import AboutUs from "./pages/AboutUs";
import CancelRide from "./components/CancelRide";
import Faqs from "./components/externaldesign/Faqs";
import Terms from "./components/externaldesign/TermsAndConditions";
import Contactus from "./components/externaldesign/Contact";
import Profile from "./pages/Profile";
import ChatPage from "./pages/ChatPage";
import RidePage from "./pages/RidePage";
import { useAuth } from "./context/AuthContext";
import HowToUse from "./components/externaldesign/HowToUse";
import SearchPage from "./pages/SearchPage";
import CallModal from "./components/CallModal";
import CallingScreen from "./components/CallingScreen";
import CallScreen from "./components/CallScreen";
import socket from "./utils/socket";
import { CallProvider, useCall } from "./context/CallContext";  // ✅ Import CallProvider and useCall
import RideEdit from "./pages/EditRidePage";
import EditProfile from "./components/EditProfileForm";


function GlobalCallUI() {
  const { incomingCall, acceptCall, rejectCall, inCall } = useCall();
  const navigate = useNavigate();

  const handleAccept = () => {
    acceptCall();
    if (incomingCall?.from) {
      navigate(`/chat/${incomingCall.from}`);
    }
  };

  return (
    <>
      {incomingCall && (
        <CallModal
          callerName={incomingCall.fromName || "Caller"}
          type={incomingCall.type}
          onAccept={handleAccept}
          onReject={rejectCall}
          
          canAccept={!inCall} 
        />
      )}
    </>
  );
}




export default function App() {
  const { user } = useAuth();

  return (
    <CallProvider>  {/* ✅ Wrap entire app with CallProvider for global state */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {/* Top Navbar */}
        <div className="navbar">
          <div className="container">
            <Navbar />
          </div>
        </div>  

        <GlobalCallUI />  {/* ✅ Global call UI component */}

        {/* Main content */}
        <main className="container" style={{ minHeight: "70vh", paddingTop: 20 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/Faqs" element={<Faqs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contactus />} />
            <Route path="/howtouse" element={<HowToUse />} />
            <Route path="/search" element={<SearchPage />} />

            {/* Ride posting (protected) */}
            <Route
              path="/post"
              element={
                <ProtectedRoute>
                  <PostRide />
                </ProtectedRoute>
              }
            />

            {/* Auth pages (guest only) */}
            <Route
              path="/phoneauth"
              element={
                <GuestOnly>
                  <PhoneAuth />
                </GuestOnly>
              }
            />
            <Route path="/login" element={<GuestOnly><LoginPage /></GuestOnly>} />

            {/* Profile page (protected) */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            {/* ✅ Chat page (protected) */}
            <Route
              path="/chat/:toId"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />

            <Route path="/ride/:id" element={<RidePage user={user} />} />
            <Route path="/ride/:id/cancel" element={<CancelRide user={user} />} />
            <Route path="/ride/:id/edit" element={<RideEdit />} />
            <Route path="/profile/edit" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />

          </Routes>
        </main>

        <Footer />
      </BrowserRouter>
    </CallProvider>
  );
}